<template>
  <div class="w-100">
    <form ref="form" v-kendo-validator novalidate>
      <div class="page-body">
        <div class="bg-white p-2 mb-3 mt-3">
          <tenant-details :readOnly="true"></tenant-details>
        </div>
        <div class="bg-white p-2 mb-3">
          <add-users :readOnly="true"></add-users>
        </div>
        <div class="bg-white p-2 mb-3">
          <add-on-selection :readOnly="true"></add-on-selection>
        </div>
        <div class="bg-white p-2 mb-3">
          <product-selection :readOnly="true"></product-selection>
        </div>
        <div class="bg-white p-2 mb-3">
          <database-config :readOnly="true"></database-config>
        </div>
        <div class="bg-white p-2 mb-3">
          <configure-saas :readOnly="true"></configure-saas>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import TenantDetails from "./TenantDetails";
import AddUsers from "./AddUsers";
import AddOnSelection from "./AddOnSelection";
import ProductSelection from "./ProductSelection";
import DatabaseConfig from "./DatabaseConfig";
import ConfigureSaas from "./SaasConfiguration";

import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["onboarding.tenantSaaS"])
  },
  methods: {
    save: function() {},
    canContinue() {
      this.$emit("can-continue", { value: true });
    }
  },
  mounted() {
    this.canContinue();
  },
  activated() {
    this.canContinue();
  },
  components: {
    TenantDetails,
    AddUsers,
    AddOnSelection,
    ProductSelection,
    DatabaseConfig,
    ConfigureSaas
  }
};
</script>

<style>
</style>